import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { inputSlotProps, inputSx } from './NewRoundModeler.styles';
import { focusNextOnEnter } from './NewRoundModeler.utils';

interface CurrencyInputCellProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

const CurrencyInputCell = ({ value, onChange, placeholder }: CurrencyInputCellProps) => (
  <NumericFormat
    value={value}
    onValueChange={({ value: raw }) => onChange(raw)}
    thousandSeparator
    prefix="$"
    valueIsNumericString
    placeholder={placeholder ?? '$0'}
    customInput={TextField}
    variant="standard"
    slotProps={{ ...inputSlotProps, htmlInput: { ...inputSlotProps.htmlInput, onKeyDown: focusNextOnEnter } }}
    sx={inputSx}
  />
);

export default CurrencyInputCell;
